import { apiClient } from '@/lib/api-client'
import type {
  VacancySuggestionDto,
  VacancyShortlistResponse,
} from '../dtos/vacancy-suggestion.dto'

export const vacancySuggestionService = {
  getShortlist: async (
    organizationId: string,
    sourceApplicationId: string,
  ): Promise<VacancyShortlistResponse> => {
    const response = await apiClient.get<VacancyShortlistResponse>(
      `/organizations/${organizationId}/vacancy-suggestions/shortlist`,
      { params: { sourceApplicationId } },
    )
    return response.data
  },

  compare: async (
    organizationId: string,
    sourceApplicationId: string,
    targetVacancyId: string,
  ): Promise<VacancySuggestionDto> => {
    const response = await apiClient.post<VacancySuggestionDto>(
      `/organizations/${organizationId}/vacancy-suggestions/compare`,
      { sourceApplicationId, targetVacancyId },
    )
    return response.data
  },

  suggest: async (
    organizationId: string,
    suggestionId: string,
    recruiterMessage: string | null,
    includeSalaryInMessage: boolean,
  ): Promise<VacancySuggestionDto> => {
    const response = await apiClient.post<VacancySuggestionDto>(
      `/organizations/${organizationId}/vacancy-suggestions/${suggestionId}/suggest`,
      { recruiterMessage, includeSalaryInMessage },
    )
    return response.data
  },

  withdraw: async (
    organizationId: string,
    suggestionId: string,
  ): Promise<VacancySuggestionDto> => {
    const response = await apiClient.post<VacancySuggestionDto>(
      `/organizations/${organizationId}/vacancy-suggestions/${suggestionId}/withdraw`,
    )
    return response.data
  },

  list: async (
    organizationId: string,
    params?: {
      candidateId?: string
      targetVacancyId?: string
      status?: string
    },
  ): Promise<VacancySuggestionDto[]> => {
    const response = await apiClient.get<VacancySuggestionDto[] | { items: VacancySuggestionDto[] }>(
      `/organizations/${organizationId}/vacancy-suggestions`,
      { params },
    )
    const data = response.data
    return Array.isArray(data) ? data : (data.items ?? [])
  },

  getById: async (
    organizationId: string,
    suggestionId: string,
  ): Promise<VacancySuggestionDto> => {
    const response = await apiClient.get<VacancySuggestionDto>(
      `/organizations/${organizationId}/vacancy-suggestions/${suggestionId}`,
    )
    return response.data
  },
}
